module.exports = __webpack_public_path__ + "img/hs_nagoya.6f48ecba.png";